<template>
  <div class="goods-detail-container">
    <div class="breadcrumb-container">
      <span style="cursor:pointer" @click="toService">服务市场</span>
      <span>&gt;</span>
      <span style="cursor:pointer" @click="intoPage">{{ detailInfo.category ? detailInfo.category.name : '' }}</span>
      <span>&gt;</span>
      <span>{{ detailInfo.name }}</span>
    </div>
    <div class="goods-info-container">
      <!-- 图片区 -->
      <div class="goods-img-container">
        <div class="goods-img-zoom">
          <PicZoom v-if="mainBigImg"
                   :minIMGsrc="mainBigImg" />
        </div>
        <div class="goods-img-list">
          <ImgCarousel :imgList="detailInfo.image"
                       @setBigImg="setBigImg" />
        </div>
      </div>
      <div class="goods-description-container">
        <div class="goods-title">{{ detailInfo.name }}</div>
        <div class="goods-price">¥ {{ goodsInfo.price }}</div>
        <div class="goods-sales">已售：{{ goodsInfo.sell_count }}+</div>
        <div class="goods-freight">运费：{{ company ? company.delivery_fee : '' }}元，满{{ company ? company.free_delivery_min : '' }}元包邮</div>
        <div class="goods-specifications"
             v-for="(item,index) in specList"
             :key="item.id">
          <span class="specifications-text">{{ item.name }}：</span>
          <div class="specifications-list-container">
            <!-- <div class="specifications-item" :class="{'active': specActiveIndex === specIndex }" v-for="(specItem,specIndex) in item.value_list" :key="specIndex">{{ specItem }}</div> -->
            <div class="specifications-item"
                 v-for="(specItem,specIndex) in item.value_list"
                 :key="specIndex"
                 @click="toSelectSpec(specItem.name,index,item,specIndex)"
                 :class="[specItem.isShow?'':'noneActive',subIndex[index] == specIndex?'active':'']">{{ specItem.name }}</div>
          </div>
        </div>
        <div class="goods-num">
          <span>数量：</span>
          <el-input-number v-model="goodsNum"
                           @change="goodsNumChange"
                           :min="1"
                           :max="+goodsInfo.stock"></el-input-number>
          <span class="goods-remain-num">剩余{{ goodsInfo.stock }}件</span>
        </div>
        <div class="goods-btn-container">
          <div class="goods-btn"
               @click="toBuyImmediately">立即购买</div>
          <div class="goods-btn plain"
               @click="toAddCart">加入购物车</div>
          <div class="contact-service"
               @click="toShowContactDialog">联系客服</div>
        </div>
      </div>

    </div>
    <div class="goods-info-detail-container"
         v-if="detailInfo.detail">
      <el-tabs v-model="tabActiveName"
               class="goods-info-detail-tab">
        <el-tab-pane label="商品详情"
                     name="tabGoodsDetail"></el-tab-pane>
      </el-tabs>
      <div class="detail-content"
           v-html="detailInfo.detail"></div>
    </div>
    <ContactDialog v-if="isshowContact"
                   @closeDialog="closeContactDialog" />
  </div>
</template>

<script>
import { getGoodsDetail, addGoodsToCart } from "@/api/home"
import PicZoom from "@/components/PicZoom"
import ImgCarousel from "@/components/ImgMulCarousel"
import { mapState } from "vuex"
import ContactDialog from '@/components/ContactDialog'
import { titleController } from "@/utils/index"
export default {
  name: 'goodsDetail',
  components: { PicZoom, ImgCarousel, ContactDialog },
  data () {
    return {
      detailInfo: {},
      goodsInfo: {
        price: '',
        sell_count: '',
        stock: 9999
      },
      goodsNum: 1,
      mainBigImg: '',
      specList: [], //规格列表
      specActiveIndex: -1,
      tabActiveName: 'tabGoodsDetail',
      selectArr: [], //存放被选中的值
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      subIndex: [], //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      selectInfo: {}, //存放选中的组合的信息 goods_id ...
      isshowContact: false
    }
  },
  computed: {
    ...mapState("company", ['company'])
  },
  async created () {
    console.log(this.$route, '商品详情')
    await this.getDetailInfo(this.$route.params.id.split('.')[0])
    window.scrollTo(0, 0)
  },
  methods: {
    toService () {
      this.$router.replace({
        name: 'ServiceMarket'
      })
    },
    //事件总线
    intoPage () {
      setTimeout(() => {
        this.$bus.$emit('getGoodsListByCategory', {
          categoryId:this.detailInfo.category.id,
          categoryName:this.detailInfo.category.name,
          pid:this.detailInfo.category.pid,
        })
      })
      localStorage.setItem('activeIndex', 3)
      this.$router.push({
        name: 'ServiceMarket'
      })
      console.log(item, '点击类别')
    },
    //加入购物车
    toAddCart () {
      if (!localStorage.getItem('token')) {
        this.$message('请先登录')
        return
      }
      if (!Object.keys(this.selectInfo).length) {
        this.$message('选择商品规格')
        return
      }
      addGoodsToCart({
        goods_sku_id: this.selectInfo.id,
        count: this.goodsNum
      }).then(res => {
        console.log(res, '加入购物车')
        if (res.code === 10000) {
          this.$message.success('加入购物车成功')
          this.$store.dispatch('cart/getCartNum')
        } else {
          this.$message.error('加入失败')
        }
      }).catch(_ => {
        this.$message.error('加入失败')
      })
    },
    // 立即购买
    toBuyImmediately () {
      console.log(this.selectInfo, '立即购买')
      if (!localStorage.getItem('token')) {
        this.$message('请先登录')
        return
      }
      if (!Object.keys(this.selectInfo).length) {
        this.$message('选择商品规格')
        return
      }
      const goodsInfo = [{
        name: this.detailInfo.name,
        count: this.goodsNum,
        skuId: this.selectInfo.id,
        spec: this.selectInfo.spec,
        img: this.detailInfo.image.length ? this.detailInfo.image[0] : '',
        price: this.goodsInfo.price,
        stock: this.goodsInfo.stock,
        isCart: 0
      }]
      localStorage.setItem('goodsInfo', JSON.stringify(goodsInfo))
      this.$router.push({
        name: 'ConfirmOrder'
      })
      console.log(goodsInfo)
    },
    closeContactDialog () {
      this.isshowContact = false
    },
    //联系客服
    toShowContactDialog () {
      this.isshowContact = true
    },
    //手动点击选择
    toSelectSpec (item, n, parentItem, index) { //属性值、规格项、
      var self = this;
      if (self.selectArr[n] != item) {
        self.selectArr[n] = item; //当前规格选中,赋值为选项的名字(蓝色、黑色)
        self.subIndex[n] = index; //设置此项为选中
      } else {
        self.selectArr[n] = "";
        self.subIndex[n] = -1; //去掉选中的颜色
      }
      self.checkItem();
    },
    //处理已选择列表
    checkItem: function () {
      var self = this;
      var option = self.specList;
      var result = []; //定义数组储存被选中的值
      for (var i in option) {
        //初始化被选中的数组，如果此类别没被选中，则赋值为空，如果有3个类别，则数组长度为3
        result[i] = self.selectArr[i] ? self.selectArr[i] : "";
      }
      //便利每个类别的每个小项
      for (var i in option) {
        var last = result[i]; //把选中的值存放到字符串last去
        for (var k in option[i].value_list) {
          result[i] = option[i].value_list[k].name; //获取每个小项的值(如：64g、128G)，并临时存放于result[i]，存在直接覆盖，不存在往里面添加name值
          option[i].value_list[k].isShow = self.isMay(result); //result数组每一次修改都将计算一次是否可以选择，添加字段isShow来判断是否可以选择
        }
        result[i] = last; //还原，目的是记录点下去那个值，避免下一次执行循环时被覆盖
      }
      //如果可获取sku，则显示当前sku价格，库存等信息
      if (this.shopItemInfo[result]) {
        this.goodsInfo.price = this.shopItemInfo[result].agent_price != null ? this.shopItemInfo[result].agent_price : this.shopItemInfo[result].price
        this.goodsInfo.sell_count = this.shopItemInfo[result].sell_count || "";
        this.goodsInfo.stock = +this.shopItemInfo[result].stock == -1 ? 9999 : this.shopItemInfo[result].stock
        this.selectInfo = this.shopItemInfo[result]
      }
      self.$forceUpdate(); //重绘
    },
    //判断每个小项是否可以选择
    isMay: function (result) {
      for (var i in result) {
        if (result[i] == "") {
          return true; //如果数组里有为空的值，则表示未被全部选择，无法获取sku，直接返回true
        }
      }
      //result选满，可获取sku，根据初始化时shopItemInfo的this.detailInfo.sku[i]键值对(64G,xxx成新)可获取sku信息
      return !this.shopItemInfo[result] || this.shopItemInfo[result].stock == 0 ? false : true; //匹配选中的数据的库存，若不为空返回true反之返回false
    },
    setBigImg (url) {
      this.mainBigImg = url
    },
    goodsNumChange (value) {
      console.log(value)
    },
    async getDetailInfo (id) {
      const res = await getGoodsDetail({ id })
      if (!res) {
        return
      }
      this.detailInfo = res.data
      this.goodsInfo.price = `${res.data.min_price} — ￥ ${res.data.max_price}`
      this.goodsInfo.sell_count = res.data.sell_count
      this.goodsInfo.stock = 9999
      this.specList = res.data.spec
      this.specList.forEach(item => {
        item.value_list = item.value_list.map(item => {
          return {
            name: item,
            isShow: true
          }
        })
      })
      let obj = {}
      //遍历sku
      for (var i in this.detailInfo.sku) {
        const item = this.detailInfo.sku[i]
        //修改数据结构格式，改成键值对的方式，以方便和选中之后的值进行匹配
        const str = Object.values(item.spec).toString()
        obj[str] = this.detailInfo.sku[i];
      }
      //赋值给全局变量
      this.shopItemInfo = obj
      this.checkItem()

      this.mainBigImg = this.detailInfo.image && this.detailInfo.image.length ? this.detailInfo.image[0] : ''
      console.log(titleController)
      if (res.data.name) {
        titleController.setRouteTitle(res.data.name)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/mixin.less";
@import "~@/styles/var.less";
.goods-detail-container {
  width: 1200px;
  margin: 50px auto 0;
}
.breadcrumb-container {
  font-size: 14px;
  font-weight: 600;
  color: @words;
  margin-left: 40px;
  margin-bottom: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  > span {
    margin-right: 4px;
  }
}
.goods-info-container {
  margin-top: 25px;
  margin-bottom: 50px;
  display: flex;
}
.goods-img-container {
  margin-right: 50px;
  width: 550px;
}
.goods-img-zoom {
  width: 510px;
  height: 510px;
  background-color: #d8d8d8;
}
.goods-img-list {
  margin-top: 34px;
}
.goods-title {
  margin-top: 25px;
  margin-bottom: 29px;
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.goods-price {
  font-size: 41px;
  font-weight: 600;
  color: @primary;
  margin-bottom: 15px;
}
.goods-sales,
.goods-freight {
  font-size: 14px;
  font-weight: 400;
  color: @words;
  line-height: 20px;
}
.goods-freight {
  margin-top: 9px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e3e3e3;
}
.goods-specifications {
  display: flex;
  margin-top: 31px;
}
.specifications-text {
  width: 150px;
  margin-right: 8px;
}
.specifications-list-container {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.specifications-item {
  padding: 4px 32px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  text-align: center;
  margin-right: 18px;
  margin-bottom: 18px;
}
.specifications-item.active {
  background: #e4f1ff;
  border-color: @primary;
  color: @primary;
}
.specifications-item.noneActive {
  background: #ccc;
  opacity: 0.4;
  color: #000;
  pointer-events: none;
}
.goods-num {
  margin-top: 36px;
}
.goods-remain-num {
  margin-left: 28px;
  font-size: 14px;
  font-weight: 400;
  color: @tipwords;
}
.goods-btn-container {
  margin-top: 44px;
  display: flex;
}
.goods-btn {
  width: 191px;
  height: 64px;
  padding: 18px 20px;
  box-sizing: border-box;
  background: @primary;
  border-radius: 14px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.goods-btn.plain {
  border: 2px solid @primary;
  background: #fff;
  color: @primary;
  margin-left: 27px;
}
.contact-service {
  margin-left: 32px;
  font-size: 20px;
  font-weight: 600;
  color: @primary;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.goods-info-detail-container {
  margin-top: 50px;
}
/deep/ .el-tabs__item.is-active {
  font-size: 20px;
  font-weight: 600;
  color: @primary;
}
/deep/ .el-tabs__active-bar {
  width: 80px !important;
  background-color: @primary;
  height: 3px;
}
/deep/.el-tabs__nav {
  margin-left: 35px;
}
.detail-content {
  margin-top: 44px;
  padding-bottom: 50px;
}
.detail-content /deep/img {
  width: 100%;
  height: auto;
  display: block;
}
</style>